import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TabName } from '../../../models/_enum-collections';
import { EngagementSearchAndFilterInput } from '../../../models/engagement-search-and-filter-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-customer-acknowledgement-queue',
  templateUrl: './customer-acknowledgement-queue.component.html',
  styleUrls: ['./customer-acknowledgement-queue.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class CustomerAcknowledgementQueueComponent implements OnInit {
  searchAndFilterInput: EngagementSearchAndFilterInput =
    new EngagementSearchAndFilterInput();
  currentSearchSubscription!: Subscription;

  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.CustomerAckApproval;
    this.prevDocumentType = PreviewDocumentTypes.customerAcknowledgement;
  }
}
